import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopulationQuery, Worksheet, WorksheetItem, WorksheetQuery, WorksheetService, WorksheetType } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-worksheet-list',
  templateUrl: './worksheet-list.component.html',
  styleUrls: ['./worksheet-list.component.scss'],
})
export class WorksheetListComponent implements OnInit {
  @Input() colOverride: string = '';
  @Input() isGalleryPage: boolean;
  @Input() isWorksheetPage: boolean;

  worksheetType = WorksheetType;
  isList: boolean = true;
  worksheets$: Observable<Worksheet[]>;
  worksheet$: Observable<Worksheet>;
  firstVideoItem: WorksheetItem | undefined;
  listVideos: WorksheetItem[] = [];
  isKid: boolean;
  selectedIndex: number = 0;

  constructor(
    private worksheetService: WorksheetService,
    private worksheetQuery: WorksheetQuery,
    private router: Router,
    private populationQuery: PopulationQuery
  ) {}
  customOptions: OwlOptions = {
    margin: 24,
    autoWidth: true,
    pullDrag: true,
    autoplay: false,
    navSpeed: 700,
    nav: false,
    dots: true,
    responsive: { 0: { items: 2 }, 900: { items: 3 } },
  };
  ngOnInit() {
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
    const currentUrl = this.router.url.replace('/', '');
    this.isWorksheetPage = this.router.url.includes('worksheet');
    this.worksheets$ = this.worksheetQuery.getWorksheetByRoute(currentUrl);
    if (!this.worksheetQuery.hasRoute(currentUrl)) {
      firstValueFrom(this.worksheetService.fetchWorksheetByRoute(currentUrl));
    }
    this.worksheets$.subscribe((worksheetItem) => {
      if (worksheetItem.length > 0) {
        this.listVideos = worksheetItem[0].Items.filter((item) => item.WorksheetType === this.worksheetType.ProviderVideo);
        this.firstVideoItem = this.listVideos?.[0];
      }
    });
  }

  onVideoSelect(event: { item: WorksheetItem & { WorksheetId: number }; index: number }): void {
    this.selectedIndex = event.index;
  }
  get selectedVideo(): WorksheetItem & { WorksheetId: number } {
    return this.listVideos[this.selectedIndex] as WorksheetItem & { WorksheetId: number };
  }
  hasWorksheetType(items: WorksheetItem[], value: number): boolean {
    const filteredItems = items?.filter((item) => item.WorksheetType === value);
    if (filteredItems?.length <= 0 || !filteredItems) {
      return false;
    } else {
      return true;
    }
  }
}
